import styled from "styled-components";
export const VoucherContainer = styled.div `
    position: relative;
	width: 1200px;
	margin: 0 auto;
	padding: 0 12px 12px;
	box-sizing: border-box;
	color: #333;
	overflow: hidden;
`;
export const VoucherItem = styled.div `
    margin: 0 auto;
	overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    & > div {
        margin-top: 12px;
    }
`;
export const VoucherCard = styled.div `
    position: relative;
    border-radius: 4px;
    overflow: hidden;

    &.exhaust,
    &.expired {
        & > .voucherImg {
            filter: grayscale(100%);
            opacity: 0.4;
        }
    }

    > .stamp {
        display: none;
        position: absolute;
        object-fit: contain;
        top: 0;
        z-index: 1;
    }

    .controllerArea > a {
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: inherit;
        text-decoration: none;
    }

    & > i.dotLeft {
        position: absolute;
        height: 26px;
        width: 13px;
        left: 0;
        border-top-right-radius: 13px;
        border-bottom-right-radius: 13px;
    }
    & > i.dotRight {
        position: absolute;
        height: 26px;
        width: 13px;
        right: 0;
        border-top-left-radius: 13px;
        border-bottom-left-radius: 13px;
    }
    .controllerArea > i.dotLeft {
        position: absolute;
        height: 26px;
        width: 13px;
        left: 0;
        border-top-right-radius: 13px;
        border-bottom-right-radius: 13px;
    }
    .controllerArea > i.dotRight {
        position: absolute;
        height: 26px;
        width: 13px;
        right: 0;
        border-top-left-radius: 13px;
        border-bottom-left-radius: 13px;
    }
`;
